<template>
  <form method="POST" @submit.prevent="submitSurvey" class="survey-container text-secondary">

    <!-- Start of question 1 -->
    <div class="question-container">
      <p class="cursor-pointer" @click="setQuestion(1)">1. {{ questions[0].content }} - <small class="text-muted">Select all that apply</small></p>

      <div class="checkboxes" v-show="currentQuestion === 1">
        <div v-for="location in locations" :key="location.id" class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
          <input type="checkbox" class="custom-control-input position-static" :id="`location-${location.id}`" :value="location.id" v-model="userLocationIds">
          <label class="custom-control-label ms-2 text-dark" :for="`location-${location.id}`">{{ location.name }}</label>
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-primary d-flex align-items-center" @click.stop="setQuestion(2)" :disabled="userLocationIds.length < 1">
            <span class="mt-1">Next</span>
            <i class="fas fa-arrow-down ms-3"></i>
          </button>
        </div>
      </div>

      <hr class="border-secondary" />
    </div>
    <!-- End of question 1 -->

    <!-- Start of question 2 -->
    <div class="question-container">
      <p class="cursor-pointer" @click="setQuestion(2)">2. {{ questions[1].content }} - <small class="text-muted">Select all that apply</small></p>

      <div class="checkboxes" v-show="currentQuestion === 2">
        <div class="scrollable">
          <div v-for="development in filteredDevelopments" class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
            <input type="checkbox" class="custom-control-input position-static" :id="`development-${development.id}`" :value="development.id" v-model="userDevelopmentIds">
            <label class="custom-control-label ms-2 text-dark" :for="`development-${development.id}`">{{ development.name }}, {{ development.location }}</label>
          </div>
          <div class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
            <input type="checkbox" class="custom-control-input position-static" id="development-other" value="other" v-model="userDevelopmentIds">
            <label class="custom-control-label ms-2 text-dark" for="development-other">I'm Not Sure</label>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-primary d-flex align-items-center" @click.stop="setQuestion(3)" :disabled="userDevelopmentIds.length < 1">
            <span class="mt-1">Next</span>
            <i class="fas fa-arrow-down ms-3"></i>
          </button>
        </div>
      </div>

      <hr class="border-secondary" />
    </div>
        <!-- End of question 2 -->

    <!-- Start of question 3 -->
    <div class="question-container">
      <p class="cursor-pointer" @click="setQuestion(3)">3. {{ questions[2].content }} - <small class="text-muted">Select all that apply</small></p>

      <div class="checkboxes" v-show="currentQuestion === 3">
        <div class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
          <input type="checkbox" class="custom-control-input position-static" id="house-all" value="all" v-model="userHouseSizes">
          <label class="custom-control-label ms-2 text-dark" for="house-all">All</label>
        </div>

        <div v-for="size in houseSizes" class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
          <input type="checkbox" class="custom-control-input position-static" :id="`house-${size}`" :value="size" v-model="userHouseSizes">
          <label class="custom-control-label ms-2 text-dark" :for="`house-${size}`">{{ size }} bed</label>
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-primary d-flex align-items-center" @click.stop="setQuestion(4)" :disabled="userHouseSizes.length < 1">
            <span class="mt-1">Next</span>
            <i class="fas fa-arrow-down ms-3"></i>
          </button>
        </div>
      </div>

      <hr class="border-secondary" />
    </div>
    <!-- End of question 3 -->

    <!-- Start of question 4 -->
    <div class="question-container">
      <p class="cursor-pointer" @click="setQuestion(4)">4. {{ questions[3].content }} - <small class="text-muted">Select one option</small></p>

      <div class="checkboxes" v-show="currentQuestion === 4">
        <div v-for="description in descriptions" class="checkbox-container custom-control custom-checkbox bg-parchment custom-control-inline p-3 mb-3">
          <input type="checkbox" class="custom-control-input position-static" :id="`description-${description}`" :value="description" v-model="userDescription">
          <label class="custom-control-label ms-2 text-dark" :for="`description-${description}`">{{ description }}</label>
        </div>
      </div>

      <hr class="border-secondary" />
    </div>
    <!-- End of question 4 -->


    <!-- Submit button -->
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-primary d-flex align-items-center" @click="submitSurvey" :disabled="submitDisabled">
        <span class="mt-1">Submit choices</span>
        <i v-if="!loading" class="far fa-check ms-3"></i>
        <span v-else class="spinner-border spinner-border-sm ms-3" role="status" aria-hidden="true"></span>
      </button>
    </div>
  </form>
</template>

<script>
export default {
  name: "UserSurveyComponent",
  data() {
    return {
      // User choices
      userLocationIds: [],
      userDevelopmentIds: [],
      userHouseSizes: [],
      userDescription: [],

      // House sizes data
      houseSizes: ['2', '3', '4', '5'],
      descriptions: [
        'Ready to move in',
        'Ready to buy',
        'Just browsing',
      ],

      // data
      currentQuestion: 1,
      loading: false,
    };
  },
  props: {
    questions: {
      type: Array,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
    },
    developments: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredDevelopments() {
      return this.developments.filter(dev => this.userLocationIds.includes(dev.region_id));
    },
    submitDisabled() {
      return this.userLocationIds.length < 1 || this.userDevelopmentIds.length < 1 || this.userHouseSizes.length < 1 || this.userDescription.length < 1;
    },
  },
  watch: {
    userDescription: function() {
      if (this.userDescription.length > 1) {
        this.userDescription.shift();
      }
    },
  },
  methods: {
    setQuestion(number) {
      if (this.currentQuestion === number) return;
      this.currentQuestion = number;
    },
    submitSurvey() {
      this.loading = true;

      axios.post(`${window.api_url}/dashboard/survey/store`, {
        questions: [
          {
            question_id: this.questions[0].id,
            answers: this.locations.reduce((acc, location) => {
              if (this.userLocationIds.includes(location.id)) {
                acc.push(location.name);
              }
              return acc;
            }, []),
          },
          {
            question_id: this.questions[1].id,
            answers: this.developments.reduce((acc, development) => {
              if (this.userDevelopmentIds.includes(development.id)) {
                acc.push(development.name);
              }
              return acc;
            }, []),
          },
          {
            question_id: this.questions[2].id,
            answers: this.userHouseSizes,
          },
          {
            question_id: this.questions[3].id,
            answers: this.userDescription,
          },
        ],
      })
        .then(() => {
          notyf.success('Your survey has been submitted successfully');
          this.loading = false;
          $('#user-survey-modal').modal('hide');
        })
        .catch(error => {
          console.error(error);
          notyf.error('Something went wrong, please try again later');
          this.loading = false;
      });
    },
  },
  mounted() {
    axios.post(`${window.api_url}/dashboard/survey/update_last_seen_time`)
      .then(response => {
        console.log(response);
      })
      .catch(error => {
        console.error(error);
      });
  }
}
</script>

<style scoped lang="scss">
.survey-container {
  min-height: 394px;

  .question-container {

    p {
      font-size: 1rem;
    }

    .checkboxes {

      .scrollable {
        max-height: 140px;
        overflow-y: auto;
      }

      .checkbox-container {
        width: 205px;
        //height: 50px;
      }
    }

    hr {
      opacity: 0.5;
    }
  }
}

</style>
